import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "mb-4 flex items-center bg-blue-50 border-l-4 border-blue-400 p-4 rounded" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "w-full max-w-4xl mx-auto bg-white rounded-lg p-8 shadow flex flex-col gap-4"
}
const _hoisted_4 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_5 = { class: "bg-white rounded-lg shadow-lg p-6 max-w-md w-full relative z-10 flex flex-col items-center gap-4" }
const _hoisted_6 = { class: "text-green-700 text-lg font-semibold text-center" }
const _hoisted_7 = {
  key: 1,
  class: "flex gap-2 w-full justify-center p-2.5 text-sm text-center text-green-800 bg-green-50 rounded-lg"
}
const _hoisted_8 = {
  key: 2,
  class: "flex gap-2 w-full justify-center p-2.5 text-sm text-center text-red-900 bg-red-50 rounded-lg"
}
const _hoisted_9 = {
  key: 3,
  class: "flex gap-2 w-full justify-center p-2.5 text-sm text-center text-green-800 bg-green-50 rounded-lg"
}
const _hoisted_10 = {
  key: 4,
  class: "flex gap-2 w-full justify-center p-2.5 text-sm text-center text-red-900 bg-red-50 rounded-lg"
}
const _hoisted_11 = { class: "flex flex-col gap-2" }
const _hoisted_12 = { class: "flex flex-col gap-2 border border-gray-200 p-2 rounded-lg" }
const _hoisted_13 = { class: "text-gray-700 text-sm font-medium text-left" }
const _hoisted_14 = {
  class: "flex flex-wrap gap-2",
  style: {"max-height":"80px","overflow-y":"auto"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "mt-4" }
const _hoisted_17 = { class: "flex flex-wrap justify-end gap-2 items-center" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_CustomMessageBox = _resolveComponent("CustomMessageBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        innerHTML: _ctx.INFO_ICON,
        class: "w-6 h-6 text-blue-400 flex-shrink-0"
      }, null, 8, _hoisted_2),
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ml-3 text-base text-gray-700 leading-normal" }, " To invite expert manually enter in email addresses and click enter/return. You can also customize the email message and decide if you want the signup link to go to your customized program landing page first or directly to the profile signup form. After you send the invites you can check the expert status in the Experts tab. ", -1))
    ]),
    (_ctx.invitationType === 'experts')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.showSuccessModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "fixed inset-0 bg-black opacity-50" }, null, -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.successMessage), 1),
                  _createVNode(_component_BaseButton, {
                    className: "bg-primary-purple text-white px-6 py-2 rounded-md text-base font-medium mt-2",
                    onClick: _ctx.handleGoBackToExperts
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Go back to Experts ")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.testEmailSuccessMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_ctx.testEmailSuccessMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.testEmailErrorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.testEmailErrorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.successMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_ctx.successMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              type: "email",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addEmail && _ctx.addEmail(...args)), ["enter"])),
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleEmailInput && _ctx.handleEmailInput(...args))),
              placeholder: "Enter an email address and hit enter/return",
              class: _normalizeClass(["flex-grow px-3.5 py-2.5 text-sm text-gray-900 bg-white rounded-md border border-gray-300 shadow-sm w-full focus:outline-none", {
          'border-red-500': _ctx.emailWarning,
          'border-gray-300': !_ctx.emailWarning,
        }])
            }, null, 34), [
              [_vModelText, _ctx.email]
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["text-xs mt-1 text-left", {
          'text-red-500': _ctx.emailWarning,
          'text-gray-400': !_ctx.emailWarning,
        }])
            }, _toDisplayString(_ctx.emailWarningMessage), 3)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, "Selected experts (" + _toDisplayString(_ctx.emailsList.length) + ")", 1),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailsList, (email, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "text-sm font-medium text-gray-700 px-2 items-center bg-gray-100 rounded-full border border-gray-300 flex"
                }, [
                  _createElementVNode("span", null, _toDisplayString(email), 1),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeEmail(index)),
                    class: "text-lg ml-2 hover:text-red-700 text-gray-700 focus:outline-none"
                  }, " x ", 8, _hoisted_15)
                ]))
              }), 128))
            ])
          ]),
          _createVNode(_component_CustomMessageBox, {
            message: _ctx.message,
            "onUpdate:message": _cache[3] || (_cache[3] = (val) => _ctx.message = val)
          }, null, 8, ["message"]),
          _createElementVNode("div", _hoisted_16, [
            _renderSlot(_ctx.$slots, "checkbox")
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearEmails && _ctx.clearEmails(...args))),
              class: "bg-gray-200 text-black px-4 py-2 rounded-md text-sm font-medium"
            }, " Clear All "),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSendTestEmail && _ctx.handleSendTestEmail(...args))),
              disabled: _ctx.sendTestEmailLoading,
              class: "bg-primary-purple text-white px-4 py-2 rounded-md text-sm font-medium"
            }, [
              (!_ctx.sendTestEmailLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Send test Email to me"))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, "Sending test email..."))
            ], 8, _hoisted_18),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendInvites && _ctx.sendInvites(...args))),
              disabled: _ctx.sendInviteLoading,
              class: "bg-primary-purple text-white px-4 py-2 rounded-md text-sm font-medium"
            }, [
              (!_ctx.sendInviteLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Send Invite"))
                : (_openBlock(), _createElementBlock("span", _hoisted_23, "Sending..."))
            ], 8, _hoisted_21)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}